<template>
  <!--<LoadingModal v-if="loading"/>-->
  <div class="pageContent">
    <div class="detailBox"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/buttons.sass'

h2.is-blank
  opacity: .25

h2.is-title
  margin-bottom: .5rem

h6
  color: gray
  font-weight: normal

.detailBox
  background: white
  box-shadow: 0 2px 3px rgba(10,10,10, .1), 0 0 0 1px rgba(10,10,10, .1)
  padding: 3.25rem 2rem
  margin: 1.75rem 0
</style>
